import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth } from '@auth/auth-context'

export function requireAuth(ComposedComponent, extraProps) {
  const Authentication = (props) => {
    const { isAuthenticated } = useAuth()

    if (!isAuthenticated) {
      return <Redirect to="/login" />
    }

    return <ComposedComponent {...props} {...extraProps} />
  }

  Authentication.displayName = `requireAuth(${ComposedComponent.displayName || ComposedComponent.name || 'Component'})`
  return Authentication
}
